<app-sidenav page="golf_classes_participants" menuType>

  <div class="class-header-card">
    <div class="header-main">
      <div class="title-row">
        <span class="class-date" *ngIf="class?.getDate()" [title]="class?.getDate() | amParse: 'YYYYMMDD' | amDateFormat: dateFormat">
          <mat-icon class="date-icon">calendar_today</mat-icon>
          <span class="date-text">{{ class?.getDate() | amParse: 'YYYYMMDD' | amDateFormat: dateFormat }}</span>
        </span>

        <h2 class="class-title" [title]="class?.getName() || ''">
          {{ class?.getName() || '' }}
        </h2>
      </div>

      <p class="teacher-name">
        <mat-icon>person</mat-icon>
        <span class="text-truncate" [title]="'Teacher: ' + (class?.getGolfteachername() || '')">
          Teacher: {{ class?.getGolfteachername() || '' }}
        </span>
      </p>
    </div>
  </div>

<div class="participants-container" *ngIf="participants$ | async as participants">

  <div class="roster-header" *ngIf="!loading">
    <span class="roster-label">{{ 'golf_classes_participants.attendees' | translate }}</span>
    <span class="roster-count" *ngIf="participants.length">{{ participants.length }}</span>
  </div>

  <mat-selection-list *ngIf="!loading && participants.length" [multiple]="false" class="attendee-list">
    <mat-list-item *ngFor="let m of participants" class="attendee-item"
    >
      <div class="w-100"
          [style.display]="'flex'"
          [style.align-items]="'center'">
      <!-- Avatar (Left side) -->
      <div matListItemAvatar class="avatar-placeholder">
        {{ m.getFirstname()?.charAt(0) }}{{ m.getLastname()?.charAt(0) }}
      </div>
      
      <!-- Name (Center/Main Content) -->
      <span matListItemTitle class="attendee-name">
        {{ m.getFirstname() }} {{ m.getLastname() }}
      </span>
      </div>
      <!-- Phone Icon / Action (Right side) -->
      <div class="col-phone">
      <a 
      mat-icon-button matListItemMeta class="phone-action" 
        [href]="tellink('tel:' + m.getProfessionaladdress()?.getMobile())"
        (click)="$event.stopPropagation();">
        <mat-icon>phone</mat-icon>
      </a>  
      <a 
      mat-icon-button matListItemMeta class="phone-action" 
        [href]="'https://wa.me/' + m.getProfessionaladdress()?.getMobile()"
        (click)="$event.stopPropagation();">
        <img src="assets/images/whatsapp-logo.png" alt="WhatsApp" class="whatsapp-icon" />
      </a>  
    </div> 
    </mat-list-item>
  </mat-selection-list>

  <div *ngIf="!loading && !participants.length" class="empty-state">
    <mat-icon class="empty-icon">group_off</mat-icon>
    <p>{{ 'golf_class.no_attendees_found' | translate }}</p>
  </div>

</div>
  <div class="participants-loading" *ngIf="loading">
    <div class="bg-overlay"></div>
    <mat-spinner class="wait-spinner" diameter="48"></mat-spinner>
  </div>

</app-sidenav>